import { render, staticRenderFns } from "./CreateFolderDialog.vue?vue&type=template&id=585513f3&"
import script from "./CreateFolderDialog.vue?vue&type=script&lang=js&"
export * from "./CreateFolderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CreateFolderDialog.vue"
export default component.exports